<p-card>
    <p-table
        #dt
        [value]="ebayMarketplaces"
        dataKey="id"
        [lazy]="true"
        [paginator]="false"
        sortField="nom"
        [sortOrder]="1"
        [columns]="selectedColumns"
        [loading]="isLoadingResults"
        [scrollable]="true"
        scrollHeight="763px"
        [expandedRowKeys]="expandedRows"
        (onLazyLoad)="onLazyLoad($event)"
        (onStateRestore)="onStateRestore($event)"
        stateKey="_besk"
        stateStorage="local"
        [defaultSortOrder]="1"
    >
        <ng-template #header let-columns>
            <tr>
                <th pFrozenColumn class="w-14"></th>
                @for (col of columns; track $index) {
                    <th>{{ col.header }}</th>
                }
                <th pFrozenColumn alignFrozen="right" class="w-14"></th>
            </tr>
        </ng-template>

        <ng-template #body let-ebayMarketplace let-columns="columns" let-expanded="expanded">
            <tr>
                <td pFrozenColumn>
                    <p-button type="button" pRipple [disabled]="ebayMarketplace.politiques_livraison === null && ebayMarketplace.aspects_noms === null" [pRowToggler]="ebayMarketplace" [text]="true" severity="secondary" [rounded]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                </td>
                @for (col of columns; track $index) {
                    @switch (col.field) {
                        @case ('tva_taux') {
                            @if (ebayMarketplace[col.field] !== null) {
                                <td>{{ ebayMarketplace[col.field] | number:'2.2-2' }}%</td>
                            }
                            @else {
                                <td>-</td>
                            }
                        }
                        @case ('actif') {
                            <td><p-badge badgeSize="small" value="&nbsp;" [severity]="ebayMarketplace[col.field] ? 'success' : 'danger'" [pTooltip]="ebayMarketplace[col.field] ? 'Publié sur Ebay' : 'Non publié sur Ebay'" tooltipPosition="bottom" class="ml-auto my-0.5" /></td>
                        }
                        @default {
                            <td>{{ ebayMarketplace[col.field] }}</td>
                        }
                    }
                }
                <td pFrozenColumn alignFrozen="right">
                    <p-button (click)="showStockModal(ebayMarketplace)" type="button" pRipple [text]="true" severity="primary" [rounded]="true" [icon]="'pi pi-pencil'" />
                </td>
            </tr>
        </ng-template>
        <ng-template #expandedrow let-ebayMarketplace>
            <tr>
                <td></td>
                <td [attr.colspan]="selectedColumns.length + 1" class="!px-0">
                    <div class="grid grid-cols-2 gap-4">
                        <div class="col-span-1 flex flex-col">
                            <h6>Aspects pour {{ ebayMarketplace.nom }}</h6>
                            <p-table
                                [value]="getAspectsKeysValues(ebayMarketplace)"
                                [paginator]="false"
                                [showCurrentPageReport]="false">
                                <ng-template #header>
                                    <tr>
                                        <th>Clé</th>
                                        <th>Valeur</th>
                                    </tr>
                                </ng-template>
                                <ng-template #body let-aspect>
                                    <tr>
                                        <td>{{ aspect.key }}</td>
                                        <td>{{ aspect.value }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template #emptymessage>
                                    <tr>
                                        <td colspan="2">Aucun aspect défini.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="col-span-1 flex flex-col">
                            <h6>Politiques de livraison pour {{ ebayMarketplace.nom }}</h6>

                            <p-table
                                [value]="ebayMarketplace.politiques_livraison"
                                [paginator]="false"
                                [showCurrentPageReport]="false">
                                <ng-template #header>
                                    <tr>
                                        <th>Policy ID</th>
                                        <th>Poids max</th>
                                    </tr>
                                </ng-template>
                                <ng-template #body let-policy>
                                    <tr>
                                        <td>{{ policy.policy_id }}</td>
                                        <td>{{ policy.poids_max }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template #emptymessage>
                                    <tr>
                                        <td colspan="2">Aucune politique de livraison définie.</td>
                                    </tr>
                                </ng-template>
                            </p-table>

                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
